import { graphql, useStaticQuery } from "gatsby"

import { ProductFlavourModel } from "../models/pages"

export const useFlavours = (locale:string) => {
 
  const queryData = useStaticQuery(graphql`
    query {
      items: allContentstackProductFlavour(
        filter: { title: { ne: "do not delete" } }
      ) {
        nodes {
          id
          uid
          url
          hero {
            heading
          }
          serving_size
          publish_details {
            locale
          }
          internal {
            type
          }
        }
      }
    }
  `)

  const items: ProductFlavourModel[] = queryData.items.nodes.filter(
    (x: ProductFlavourModel) => x.publish_details.locale === locale
  )

  return items
}

export default useFlavours
